= <template>
    <div class="HistoricField">
        <DataGrid
            v-if="data"
            ref="dataGrid"
            class="DataGrid mb-2"
            v-bind="dataGridConfig"
            :loading="isLoading"
            :columns="data.columns ? data.columns : []"
            :rows="data.rows ? data.rows : []"
            :formatDate="formatDate"
            @onSelectionChanged="handleRowSelected"
        />

        <div class="flex row-right-center">
            <WButton
                color="accent-blue"
                outline
                :disabled="isLoading || isUpdating"
                @click="$emit('onCancel')"
            >
                {{ $t('actions.cancel') }}
            </WButton>
            <WButton
                color="primary"
                :loading="isUpdating"
                :disabled="isLoading || !selectedNodes.length"
                class="ml-1"
                @click="update"
            >
                {{ $t('actions.apply') }}
            </WButton>
        </div>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
import { DataGrid } from '@/components'
import {
    Api, apiRequest, rethrowError, notifyError,
} from '@/api'
import GridEntity from '@/entities/grid'

const DATAGRID_CONFIG = {
    hasInputFilter: false,
    filterable: false,
    sideBar: false,
    cleanFiltersButton: false,
    editable: false,
    fitResponsive: true,
    rowSelection: 'single',
    defaultColDef: {
        checkboxSelection: GridEntity.isFirstCol,
    },
}

const UPDATE_OPTIONS = {
    timeout: 0,
}

export default {
    name: 'HistoricField',
    components: {
        DataGrid,
    },
    props: {
        entityKey: VueTypes.string,
        field: VueTypes.string,
        node: VueTypes.any,
        formatDate: VueTypes.string.def('HH:mm DD/MM/YYYY'),
    },
    data () {
        return {
            dataGridConfig: DATAGRID_CONFIG,

            data: undefined,
            selectedNodes: [],
            isLoading: false,
            isUpdating: false,
        }
    },
    mounted () {
        const { data } = this.node || {}
        const { id } = data || {}
        this.rowKey = id
        this.get()
    },
    methods: {
        handleRowSelected ({ api }) {
            this.selectedNodes = api.getSelectedNodes()
        },
        async get () {
            const params = { entityKey: this.entityKey, rowKey: this.rowKey, fieldKey: this.field }
            this.isLoading = true
            apiRequest(Api().outputs.historic(params))
                .then(({ data }) => (this.data = data))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isLoading = false))
        },
        async update () {
            const { value } = (this.selectedNodes[0] || []).data
            const params = {
                type: this.entityKey,
                row: { id: this.rowKey, [this.field]: value },
            }
            this.isUpdating = true
            apiRequest(Api().imports.create(params, UPDATE_OPTIONS))
                .then(() => this.$emit('onChange', { ...this.node.data, [this.field]: value }))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isUpdating = false))
        },
    },
}
</script>
<style lang="scss" scoped>
.HistoricField {
    min-height: 250px;
}

.DataGrid {
    width: 100%;
    height: 250px;
}
</style>
